import * as React from 'react';

export default function PebbleLoading(props) {
    return (
        <div className="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    )
}


// WEBPACK FOOTER //
// ./src/js/ui/PebbleLoading.jsx